/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */
import {
  useQuery,
  type DataTag,
  type QueryClient,
  type QueryFunction,
  type QueryKey,
  type UseQueryOptions,
  type UseQueryReturnType,
} from "@tanstack/vue-query"
import { computed, toValue, unref, type MaybeRefOrGetter } from "vue"

import { customInstance, type ErrorType } from ".././client.ts"
import { useQueryOptions } from ".././queryOptions.ts"
import type { AddressMeterPointDetails, Error, Postcode } from "../model"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * return a list of addresses for a given postcode with an indication for those with billing accounts
 * @summary return a list of addresses for a given postcode with an indication for those with billing accounts
 */
export const addressesByPostcode = (
  postcode: MaybeRefOrGetter<Postcode>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  postcode = toValue(postcode)

  return customInstance<AddressMeterPointDetails[]>(
    { url: `/api/v1/addresses/${postcode}`, method: "GET", signal },
    options,
  )
}

export const getAddressesByPostcodeQueryKey = (
  postcode: MaybeRefOrGetter<Postcode>,
) => {
  return ["api", "v1", "addresses", postcode] as const
}

export const useAddressesByPostcodeQueryOptions = <
  TData = Awaited<ReturnType<typeof addressesByPostcode>>,
  TError = ErrorType<Error>,
>(
  postcode: MaybeRefOrGetter<Postcode>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addressesByPostcode>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getAddressesByPostcodeQueryKey(postcode)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof addressesByPostcode>>
  > = ({ signal }) => addressesByPostcode(postcode, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(postcode) !== null && toValue(postcode) !== undefined,
      ),
      ...queryOptions,
    },
    { postcode },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof addressesByPostcode>>,
    TError,
    TData
  >
}

export type AddressesByPostcodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof addressesByPostcode>>
>
export type AddressesByPostcodeQueryError = ErrorType<Error>

/**
 * @summary return a list of addresses for a given postcode with an indication for those with billing accounts
 */

export function useAddressesByPostcode<
  TData = Awaited<ReturnType<typeof addressesByPostcode>>,
  TError = ErrorType<Error>,
>(
  postcode: MaybeRefOrGetter<Postcode>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addressesByPostcode>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useAddressesByPostcodeQueryOptions(postcode, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}
